import { computed } from 'vue'
import type { Ref, ComputedRef } from 'vue'

interface DialogRef {
  value?: {
    data?: Record<string, any>
  }
}

export function useDialogDataProperty<T>(
  dialogRef: Ref<DialogRef | undefined>,
  propertyKey: string,
): ComputedRef<T | undefined> {
  return computed(() => dialogRef?.value?.data?.[propertyKey] as T | undefined)
}
